<footer class="site-footer"{{{ root }}}>
  <div class="shell footer-inner">
    <p class="footer-mark"{{{ mark.attrs }}}>{{{ mark.html }}}</p>
    <ul class="footer-links">
{{#each links}}
      <li{{{ edit }}}><a href="{{ href }}"{{#if lang}} lang="{{ lang }}"{{/if}}{{{ label.attrs }}}>{{{ label.html }}}</a></li>
{{/each}}
    </ul>
    <p class="footer-legal"{{{ legal.attrs }}}>{{{ legal.html }}}</p>
  </div>
</footer>
